import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL } from "../config";

export const Preloader = () => {
  const [show, setShow] = useState(
    () => window.location.pathname === "/" && !sessionStorage.getItem("themaya_intro")
  );

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      sessionStorage.setItem("themaya_intro", "1");
      setShow(false);
    }, 2400);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <div data-testid="luxury-preloader" className="fixed inset-0 z-[100]">
          <motion.div
            className="absolute inset-x-0 top-0 h-1/2 bg-luxury-black border-b border-luxury-gold/30"
            exit={{ y: "-100%" }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          />
          <motion.div
            className="absolute inset-x-0 bottom-0 h-1/2 bg-luxury-black border-t border-luxury-gold/30"
            exit={{ y: "100%" }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          />
          <motion.div
            className="absolute inset-0 flex flex-col items-center justify-center"
            exit={{ opacity: 0, scale: 1.06, filter: "blur(6px)" }}
            transition={{ duration: 0.55, ease: "easeIn" }}
          >
            <motion.img
              src={LOGO_URL}
              alt="TheMaya"
              className="h-24 md:h-36 w-auto"
              initial={{ opacity: 0, scale: 0.82, filter: "blur(10px)" }}
              animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            />
            <motion.div
              className="mt-8 h-px bg-gradient-to-l from-transparent via-luxury-gold to-transparent"
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: 240, opacity: 1 }}
              transition={{ delay: 0.55, duration: 1.3, ease: "easeOut" }}
            />
            <motion.p
              className="mt-6 text-luxury-gray text-[11px] tracking-[0.55em] uppercase"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1, duration: 0.8 }}
            >
              TheMaya
            </motion.p>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
